export default function LoadingComponent() {
    return <p>Authentication in progress...</p>;
}